import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import HeadTags from 'shared/HeadTags';
import ym from 'react-yandex-metrika';
import { useGetMassagePageTextQuery } from 'services/api/api';
import LoadingBlock from 'shared/LoadingBlock';
import Breadcrumbs from 'shared/Breadcrumbs';
import ServiceGallery from 'shared/ServiceGallery';
import parse from 'html-react-parser';
import './massage.style.scss';
const honeyImg = require("assets/img/massage_honey.jpg");
const sportImg = require("assets/img/massage_sport.jpg");
const brazilImg = require("assets/img/massage_brazil.jpg");
const specialImg01 = require("assets/img/massage_special_01.jpg");
const specialImg02 = require("assets/img/massage_special_02.jpg");
const specialImg03 = require("assets/img/massage_special_03.jpg");
const specialImg04 = require("assets/img/massage_special_04.jpg");
const startImg = require("assets/img/massage_start.jpg");
const afroditaImg = require("assets/img/massage_afrodita.jpg");
const specialImg05 = require("assets/img/massage_special_05.jpg");
const specialImg06 = require("assets/img/massage_special_06.jpg");
const specialImg07 = require("assets/img/massage_special_07.jpg");
const specialImg08 = require("assets/img/massage_special_08.jpg");
const stepsImg = require("assets/img/massage_steps.jpg");



const MassagePage = () => {
    const navigate = useNavigate();
    const { data, isLoading, isError } = useGetMassagePageTextQuery();

    // useEffect(() => {
    //     ym('hit', '/uslugi/massage');
    //     window.scrollTo({
    //         top: 0,
    //         behavior: "smooth"
    //     });
    // }, [navigate]);

    return (
        <div className="massage service-page">
            <LoadingBlock isLoading={isLoading} >
                {isError
                    ? <p>Ошибка получения данных</p>
                    : <>
                        <HeadTags
                            title={data && data.seo?.title ? data.seo.title : 'Массаж'}
                            metaDescription={data && data.seo?.description ? data.seo.description : 'Массаж'}
                        />
                        <div className="container">
                            <Breadcrumbs pageName={data?.title} isService = {true}/>
                            <h1>{data?.title}</h1>
                        </div>
                        <section className="massage_manual">
                            <div className="container">
                                <div className="massage_row row">
                                    <div className="massage_row__text">
                                        <div className="massage_row__billet billet">
                                            <h2>{data?.first_block_title}</h2>
                                            <div className="paragraph-decor">{data?.first_block_first_text && parse(data?.first_block_first_text)}</div>
                                        </div>
                                        <div className="massage_row__block">{data?.first_block_second_text && parse(data?.first_block_second_text)}</div>
                                    </div>
                                    {data?.first_block_photo && <div className="massage_row__img">
                                        <img src={data?.first_block_photo} alt="Ручной массаж" title="Ручной массаж"/>
                                    </div>}
                                </div>
                            </div>
                        </section>
                        <section className="massage_honey">
                            <div className="container">
                                <div className="massage_row massage_row--right row">
                                    <div className="massage_row__img">
                                        <img src={honeyImg} alt="Медовый массаж" />
                                    </div>
                                    <div className="massage_row__text">
                                        <div className="massage_row__billet billet">
                                            <h2>Медовый массаж</h2>
                                            <div className="paragraph-decor">
                                                <p style={{lineHeight:'1.45em'}}>Медовый массаж — это не просто уход за телом, это настоящее волшебство для вашей кожи! 
                                                Это коррекционная процедура с заметным лифтинг-эффектом.<br/>
                                                Благодаря уникальным свойствам меда, он улучшает кровообращение, очищает от токсинов и дарит невероятную упругость. 
                                                Уже через несколько сеансов вы заметите, как кожа становится гладкой, бархатной, а тело — стройным и подтянутым</p>
                                            </div>
                                        </div>
                                        <div className="massage_row__block">
                                            <p style={{lineHeight:'1.75em'}}>Чтобы иметь красивое и здоровое тело, нужно заботиться о себе 2-3 раза в неделю. Это не просто процедура, 
                                                а акт любви к себе! Уход за собой — это наслаждение, радость и счастье<br/>
                                                Только счастливый человек может делиться этой любовью с близкими.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="massage_hardware">
                            <div className="container">
                                <div className="massage_row row">
                                    <div className="massage_row__text">
                                        <div className="massage_row__billet billet">
                                            <h2>{data?.second_block_title}</h2>
                                            <div className="paragraph-decor">{data?.second_block_text && parse(data?.second_block_text)}</div>
                                        </div>
                                        <div className="massage_row__block">
                                            <p>{data?.second_block_list_title}</p>
                                            <ul className="massage_row__list">
                                                <li>{data?.second_block_list_first_item}</li>
                                                <li>{data?.second_block_list_second_item}</li>
                                                <li>{data?.second_block_list_third_item}</li>
                                                <li>{data?.second_block_list_fourth_item}</li>
                                                <li>{data?.second_block_list_fifth_item}</li>
                                            </ul>
                                        </div>
                                    </div>
                                    {data?.second_block_photo && <div className="massage_row__img">
                                        <img src={data?.second_block_photo} alt="Аппаратный массаж" title="Аппаратный массаж"/>
                                    </div>}
                                </div>
                            </div>
                        </section>
                        <section className="massage_sport">
                            <div className="container">
                                <div className="massage_row massage_row--right row">
                                    <div className="massage_row__img">
                                        <img src={sportImg} alt="Спортивный массаж" />
                                    </div>
                                    <div className="massage_row__text">
                                        <div className="massage_row__billet billet">
                                            <h2>Спортивный массаж</h2>
                                            <div className="paragraph-decor">
                                                <p>Спортивный массаж подойдёт всем, кто занимается спортом или ведёт активный образ жизни. Он будет 
                                                    полезен профессиональным спортсменам и спортсменам-любителям, так как помогает повысить физическую 
                                                    выносливость, снизить утомляемость и болевые ощущения, а также способствует быстрому восстановлению 
                                                    после тренировок и соревнований</p>
                                            </div>
                                        </div>
                                        <div className="massage_row__block">
                                            <ul className="massage_row__list">
                                                <li>Положительное воздействие на нервно-мышечный аппарат;</li>
                                                <li>Улучшение крово- и лимфообращения;</li>
                                                <li>Стимуляция обменных процессов в организме;</li>
                                                <li>Насыщение мышц кислородом и питательными веществами;</li>
                                                <li>Помощь в освобождении мышц от шлаков и токсинов, в частности от молочной кислоты;</li>
                                                <li>Повышение эластичности связок;</li>
                                                <li>Улучшение состояния суставов и окружающих их тканей;</li>
                                                <li>Расслабление, успокоение и снижение уровня гормона стресса — кортизола;</li>                                                
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <section className="massage_brazilian">
                            <div className="container">
                                <div className="massage_row row">
                                    <div className="massage_row__text">
                                        <div className="massage_row__billet billet">
                                            <h2>«Бразильская попа»</h2>
                                            <div>
                                                <p className="paragraph-decor">Это антицеллюлитный массаж бедер и ягодиц, направленный на моделирование фигуры. 
                                                    Процедура сочетает 3 эстетических массажных техники, а также используются специальные бамбуковые палочки</p>
                                                <p className="paragraph-decor">Процедура подойдет желающим улучшить форму ягодиц и девушкам с плоской фигурой. 
                                                    Также данный массаж поможет исправить обвисшие ягодицы и целлюлит 1-2 стадии</p>
                                                <p className="paragraph-decor massage_paragraph__big">Длительность одного сеанса: 1 час</p>
                                            </div>
                                        </div>
                                        <div className="massage_row__block">
                                            <ul className="massage_row__list massage_row__list--column">
                                                <li><b>Эффект от процедуры:</b></li>
                                                <li>Моделирование и увеличение объема ягодиц;</li>
                                                <li>Устранение целлюлита;</li>
                                                <li>Уменьшение подъягодичного валика;</li>
                                                <li>Сглаживание складок;</li>
                                                <li>Улучшение качества кожи;</li>
                                                <li>Расщепление жировых отложений;</li>
                                                <li>Коррекция пропорций фигуры;</li>
                                                <li>Улучшение кровообращения;</li>
                                                <li>Тонизирование мышц;</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="massage_row__img">
                                        <img src={brazilImg} alt="Массаж Бразильская попа" title="Массаж Бразильская попа"/>
                                    </div>
                                </div>
                                <div className="massage_special">
                                    <h2>Особенности проведения:</h2>
                                    <ul className="massage_special__list">
                                        <li>
                                            <img src={specialImg01} alt="Сначала мастер разогревает кожу маслом" />
                                            <span>Сначала мастер<br/> разогревает кожу маслом</span>
                                        </li>
                                        <li>
                                            <img src={specialImg02} alt="Используются специальные бамбуковые палочки" />
                                            <span>Используются специальные<br/> бамбуковые палочки</span>
                                        </li>
                                        <li>
                                            <img src={specialImg03} alt="Направление движений от периферии к центру" />
                                            <span>Направление движений<br/> от периферии к центру</span>
                                        </li>
                                        <li>
                                            <img src={specialImg04} alt="Процедура безболезненна, синяки не остаются" />
                                            <span>Процедура безболезненна,<br/> синяки не остаются</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </section> */}
                        <section className="massage_start">
                            <div className="container">
                                <div className="massage_row row">
                                    <div className="massage_row__text">
                                        <div className="massage_row__billet billet">
                                            <h2>Перед началом курса</h2>
                                            <div className="paragraph-decor">
                                                <p>Необходимо проконсультироваться с врачом, т.к. процедура относится 
                                                к&nbsp;СПА&#8209;массажу и не является медицинской услугой</p>
                                                <p>Для достижения стойкого результата рекомендуется пройти курс из 5-7 сеансов</p>
                                                <p>Между сеансами должен быть перерыв 1-2 дня для закрепления эффекта</p>
                                            </div>
                                        </div>
                                        <div className="massage_row__block">
                                            <h2>Результаты после первого сеанса:</h2>
                                            <ul className="massage_row__list massage_row__list--column">
                                                <li>Изгиб спины становится более выраженным;</li>
                                                <li>Ягодицы более упругие;</li>
                                                <li>Переход от ягодиц к ногам становится более плавным;</li>
                                                <li>Исчезает рыхлость</li>                                             
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="massage_row__img">
                                        <img src={startImg} alt="Аппаратный массаж" title="Аппаратный массаж"/>
                                    </div>
                                </div>
                                <div className="massage_additional">
                                    <h2>Дополнительные рекомендации и особенности процедуры:</h2>
                                    <ul className="massage_additional__list massage_row__list--column">
                                        <li>Эффект заметен уже после первого сеанса</li>
                                        <li>Для лучшего результата можно сочетать с физическими нагрузками</li>
                                        <li>Уменьшение объемов происходит постепенно</li>
                                        <li>При значительных объемах сначала проявляется тонизирующий эффект</li>
                                        <li>Воздействие осуществляется не только на ягодицы, но и на бедра</li>
                                        <li>Запускается восстановительный процесс во всем теле</li>
                                        <li>Приводит в тонус все мышцы, усиливает обменные процессы</li>
                                        <li>Помогает избавиться от жировых накоплений</li>
                                        <li>Устраняет эффект «апельсиновой корки»</li>
                                    </ul>
                                </div>
                            </div>
                        </section>
                        <section className="massage_afrodita">
                            <div className="container">
                                <div className="massage_row massage_row--right row">
                                    <div className="massage_row__img">
                                        <img src={afroditaImg} alt="Массаж «Афродита»" />
                                    </div>
                                    <div className="massage_row__text">
                                        <div className="massage_row__billet billet">
                                            <h2>Массаж «Афродита»</h2>
                                            <div className="paragraph-decor">
                                                <p>Это специализированная антицеллюлитная процедура для женщин, направленная на проработку проблемных зон тела</p>
                                                <p>Процедура подойдет :<br/>
                                                    •&nbsp;&nbsp;При наличии целлюлита<br/>
                                                    •&nbsp;&nbsp;При застойных явлениях в области таза и бедер<br/>
                                                    •&nbsp;&nbsp;При небольших нарушениях эстрогенового баланса<br/>
                                                    •&nbsp;&nbsp;При излишних жировых отложениях в области таза и бедер
                                                </p>
                                                <p className="massage_paragraph__big">Продолжительность сеанса: 1 – 1.5 часа</p>
                                            </div>
                                        </div>
                                        <div className="massage_row__block">
                                            <ul className="massage_row__list massage_row__list--column">
                                                <li><b>Эффект от процедуры:</b></li>                                                
                                                <li>Улучшение настроения и самочувствия;</li>
                                                <li>Уменьшение отечности;</li>
                                                <li>Снижение веса и объемов тела;</li>
                                                <li>Улучшение структуры и тонуса кожи;</li>
                                                <li>Формирование изящных линий тела;</li>
                                                <li>Повышение стрессоустойчивости;</li>
                                                <li>Нормализация гормонального фона</li> 
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="massage_special">
                                    <h2>Особенности проведения:</h2>
                                    <ul className="massage_special__list">
                                        <li>
                                            <img src={specialImg05} alt="Комплексная антицеллюлитная техника" />
                                            <span>Комплексная<br/> антицеллюлитная техника</span>
                                        </li>
                                        <li>
                                            <img src={specialImg06} alt="Проработка мышц и подкожно-жировой клетчатки" />
                                            <span>Проработка мышц<br/> и подкожно-жировой клетчатки</span>
                                        </li>
                                        <li>
                                            <img src={specialImg07} alt="Глубокое воздействие на проблемные зоны" />
                                            <span>Глубокое воздействие<br/> на проблемные зоны</span>
                                        </li>
                                        <li>
                                            <img src={specialImg08} alt="Практически безболезненная методика" />
                                            <span>Практически безболезненная<br/> методика</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </section>
                        <section className="massage_steps">
                            <div className="container">
                                <div className="massage_row row">
                                    <div className="massage_row__text">
                                        <div className="massage_row__billet billet">
                                            <h2>Основные этапы процедуры:</h2>
                                            <div className="paragraph-decor">
                                                <ul className="massage_row__list">
                                                    <li>Нанесение специальных средств;</li>  
                                                    <li>Разогрев тканей;</li>
                                                    <li>Проработка глубоких мышц;</li>
                                                    <li>Работа с подкожно-жировой клетчаткой;</li>
                                                    <li>Лимфатический дренаж</li>                                           
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="massage_row__block">
                                            <h2>Особое внимание зонам:</h2>
                                            <div className="paragraph-decor">
                                                <ul className="massage_steps__list">
                                                    <li>Таз</li>
                                                    <li>Бедра</li>
                                                    <li>Живот</li>
                                                    <li>Колени</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="massage_row__img">
                                        <img src={stepsImg} alt="Аппаратный массаж" title="Аппаратный массаж"/>
                                    </div>
                                </div>
                                <div className="massage_additional">
                                    <h2>Дополнительные рекомендации и особенности процедуры:</h2>
                                    <ul className="massage_additional__list">
                                        <li>Для достижения устойчивого эффекта необходим курс процедур</li>
                                        <li>Техника включает как поверхностную, так и глубокую проработку</li>
                                        <li>Особое внимание уделяется снижению болевых ощущений</li>
                                        <li>Процедура включает элементы прогрева и растяжки</li>
                                        <li>Проходить курс массажа под руководством специалиста</li>
                                        <li>Соблюдать регулярность процедур</li>
                                        <li>Сочетать массаж с правильным питанием и физической активностью</li>
                                        <li>Пить достаточное количество воды после процедуры</li>
                                    </ul>
                                    <p>Для достижения максимального результата рекомендуется пройти полный курс массажа «Афродита», так как единичные процедуры не дадут стойкого эффекта</p>
                                </div>
                            </div>           
                        </section>
                        <section className="massage_therapy">
                            <div className="container">
                                <h2>{data?.third_block_title}</h2>
                                <div className="massage_therapy__row row">
                                    {data?.third_block_photo && <div className="massage_therapy__img">
                                        <img src={data?.third_block_photo} alt="Прессотерапия" title="Прессотерапия"/>
                                    </div>}
                                    <div className="massage_therapy__text">{data?.third_block_first_text && parse(data?.third_block_first_text)}</div>
                                    <div className="massage_therapy__block">
                                        <div className="paragraph-decor">{data?.third_block_second_text && parse(data?.third_block_second_text)}</div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {
                            data?.gallery_images.length ? ( 
                                <div className="service_gallery">
                                    <h2>Фото массажа, расслабление и оздоровление.</h2>                                                                   
                                    <ServiceGallery slides ={data.gallery_images} name={data?.title} />   
                                </div>                             
                            ) : null
                        }
                    </>
                }
            </LoadingBlock>
        </div >
    );
};
export default MassagePage;